module.exports = __webpack_public_path__ + "static/media/leaf.d3f2a05d.svg";